export default __webpack_public_path__ + "static/media/4.c1ada653.JPEG";